<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <!-- table 1 -->
  <app-chart-download-button (buttonClick)="exportBknAusbildungTable()">
    <h2 class="title" translate>m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.title
    </h2>
  </app-chart-download-button>
  <app-matrix-total-table [data]="bknAusbildungData"
    rowHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.ausbildung"
    columnHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.bkn"
    #bknAusbildungTable>
  </app-matrix-total-table>

  <!-- table 2 -->
  <app-chart-download-button (buttonClick)="exportBstAusbildungTable()">
    <h2 class="title" translate>m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table2.title
    </h2>
  </app-chart-download-button>
  <app-matrix-total-table [data]="bstAusbildungData"
    rowHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.ausbildung"
    columnHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.bst"
    #bstAusbildungTable>
  </app-matrix-total-table>

  <!-- table 3 -->
  <app-chart-download-button (buttonClick)="exportBstBknTable()">
    <h2 class="title" translate>m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table3.title
    </h2>
  </app-chart-download-button>
  <app-matrix-total-table [data]="bknBstData"
    rowHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.bkn"
    columnHeader="m1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.colhead.bst"
    #bstBknTable>
  </app-matrix-total-table>
</div>
